"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logDebug = exports.logInfo = exports.logWarning = exports.logError = exports.log = void 0;
const rollbar_1 = __importDefault(require("rollbar"));
const utils_1 = require("./utils");
const accessToken = process.env.ROLLBAR_ACCESS_TOKEN || process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN || process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN;
const environment = process.env.ENV || process.env.VUE_APP_ENV || process.env.REACT_APP_ENV;
const rollbar = new rollbar_1.default({
    accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    autoInstrument: false,
    payload: { environment }
});
// prevent rollbar from grouping messages together by giving them all unique fingerprints
rollbar.configure({
    transform: (payload) => {
        payload.fingerprint = (0, utils_1.generateKey)(32);
    }
});
function log(message, data) {
    try {
        console.log(message, data);
        rollbar.log(message, data);
    }
    catch (error) {
        console.error('Failed to write Rollbar log', error);
    }
}
exports.log = log;
function logError(message, err) {
    try {
        console.error(message, err);
        rollbar.error(message, err);
    }
    catch (error) {
        console.error('Failed to write Rollbar error', error);
    }
}
exports.logError = logError;
function logWarning(message, data) {
    try {
        console.warn(message, data);
        rollbar.warn(message, data);
    }
    catch (error) {
        console.error('Failed to write Rollbar warning', error);
    }
}
exports.logWarning = logWarning;
function logInfo(message, data) {
    try {
        console.info(message, data);
        rollbar.info(message, data);
    }
    catch (error) {
        console.error('Failed to write Rollbar info', error);
    }
}
exports.logInfo = logInfo;
function logDebug(message, data) {
    try {
        console.debug(message, data);
        rollbar.debug(message, data);
    }
    catch (error) {
        console.error('Failed to write Rollbar debug', error);
    }
}
exports.logDebug = logDebug;
